/*
  Following is a list of layers for GOES-R PLT Field Campaign.
  TODO: In future make this customizable as more field campaign data is prepared to be shown using FCX
 */

  import { dataBaseUrl, abiBaseUrl, flightTrackBaseUrl } from "../../config"

  const layers_2017_05_17 = [
    {
      layerId: "2017-05-17-abi-13",
      fieldCampaignName: "GOES-R PLT",
      shortName: "abi_c13",
      displayName: "Advanced Baseline Imager",
      variableName: "Channel 13",
      date: "2017-05-17",
      start: "2017-05-17T00:00:00Z",
      end: "2017-05-17T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      displayMechanism: "wmts",
      url: `${abiBaseUrl}/development/singleband/C13/{Time}/{TileMatrix}/{TileCol}/{TileRow}.png?colormap=cloud`,
      format: "image/png",
      style: "default",
      times: [
        '548258538', '548258838', '548259138', '548259438', '548259738', '548260038', '548260338', '548260638', '548260938', '548261238', '548261538', '548261838', '548262138', '548262438', '548262738', '548263038', '548263338', '548263638', '548263938', '548264238', '548264538', '548264838', '548265138', '548265438', '548265738', '548266038', '548266338', '548266638', '548266938', '548267238', '548267538', '548267838', '548268138', '548268438', '548268738', '548269038', '548269338', '548269638', '548269938', '548270238', '548270538', '548270838', '548271138', '548271438', '548271738', '548272038', '548272338', '548272638', '548272938', '548273238', '548273538', '548273838', '548274138', '548274438', '548274738', '548275038', '548275338', '548275638', '548275938', '548276238', '548276538', '548276838', '548277138', '548277438', '548277738', '548278038', '548278338', '548278638', '548278938', '548279238', '548279538', '548279838'
      ],
      tileMatrixSetID: "2km",
      layer: "ABI_Channel_13",
    },
  
    {
      layerId: "2017-05-17-glm",
      fieldCampaignName: "GOES-R PLT",
      shortName: "glm_intensity",
      displayName: "Geostationary Lightning Mapper",
      variableName: "Lightning Events",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-17/glm_czml_1min/GLM_tiles.czml`,
      date: "2017-05-17",
      start: "2017-05-17T00:00:00Z",
      end: "2017-05-17T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      displayMechanism: "czml",
    },  
    {
      layerId: "2017-05-17-glp",
      fieldCampaignName: "GOES-R PLT",
      shortName: "glm",
      addOnTickEventListener: true,
      displayName: "Geostationary Lightning Mapper Intensity",
      variableName: "Lightning Events",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-17/glm_points/GLMpoints.json`,
      date: "2017-05-17",
      start: "2017-05-17T00:00:00Z",
      end: "2017-05-17T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      dispType: 'Intensity',
      displayMechanism: "points",
    },
    {
      layerId: "2017-05-17-isslis",
      fieldCampaignName: "GOES-R PLT",
      shortName: "isslis",
      displayName: "ISS LIS",
      variableName: "Lightning Events",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-17/iss-lis_czml/LIS_tiles.czml`,
      start: "2017-05-17T05:43:48Z",
      end: "2017-05-17T05:46:59Z",
      date: "2017-05-17",
      type: "instrument",
      platform: "satellite",
      displayMechanism: "czml",
    }, 
    {
      layerId: "2017-05-17-lisp",
      fieldCampaignName: "GOES-R PLT",
      shortName: "isslis",
      addOnTickEventListener: true,
      displayName: "ISS LIS Intensity",
      variableName: "Lightning Events",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-17/iss-lis_points/LISpoints.json`,
      date: "2017-05-17",
      start: "2017-05-17T00:00:00Z",
      end: "2017-05-17T23:59:59Z",
      type: "instrument",
      dispType: 'LIntensity',
      platform: "satellite",
      displayMechanism: "points",
    },
    {
      layerId: "2017-05-17-crs",
      fieldCampaignName: "GOES-R PLT",
      shortName: "goesrpltcrs",
      addOnTickEventListener: true,
      displayName: "Cloud Radar System",
      variableName: "Radar Reflectivity",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-17/crs/tileset.json`,
      date: "2017-05-17",
      start: "2017-05-17T02:28:33Z",
      end: "2017-05-17T07:35:23Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "3dtile",
    }, 
    {
      layerId: "2017-05-17-cpl",
      fieldCampaignName: "GOES-R PLT",
      shortName: "goesrpltcpl",
      addOnTickEventListener: true,
      displayName: "Cloud Physics LiDAR",
      variableName: "Radar Reflectivity",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-17/cpl/cpl_atb/tileset.json`,
      date: "2017-05-17",
      start: "2017-05-17T02:28:33Z",
      end: "2017-05-17T09:10:53Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "3dtile",
    },  
    {
      layerId: "2017-05-17-fegs",
      shortName: "goesrpltfegs",
      displayName: "Fly's Eye GLM Event Simulator",
      variableName: "Lightning Radiance Detected",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-17/fegs/FEGS_Flash.czml`,
  
      date: "2017-05-17",
      start: "2017-05-17T02:28:33Z",
      end: "2017-05-17T07:35:23Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-17-lip",
      shortName: "goesrpltlip",
      displayName: "Lightning Instrument Package",
      variableName: "Electric Field",
      unit: "kV/m",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-17/lip/LIP.czml`,
      date: "2017-05-17",
      start: "2017-05-17T02:28:33Z",
      end: "2017-05-17T07:35:23Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-17-lma1",
      shortName: "goesrpltoklma",
      displayName: "Oklahoma Lightning Mapping Array (LMA)",
      variableName: "Lightning Events",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-17/lma1/OKLMA_tiles.czml`,
      date: "2017-05-17",
      start: "2017-05-17T00:00:00Z",
      end: "2017-05-17T23:59:59Z",
      type: "instrument",
      platform: "ground",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-17-lma1-stations",
      shortName: "lma_stations",
      displayName: "Oklahoma LMA Stations",
      variableName: "Station Location",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/LMA_asset/OKLMA_stations.czml`,
      date: "2017-05-17",
      start: "2017-05-17T00:00:00Z",
      end: "2017-05-17T23:59:59Z",
      type: "instrument",
      platform: "ground",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-17-lma2",
      shortName: "goesrpltwtlma",
      displayName: "West Texas Lightning Mapping Array (LMA)",
      variableName: "Lightning Events",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-17/lma2/WTXLMA_tiles.czml`,
      date: "2017-05-17",
      start: "2017-05-17T00:00:00Z",
      end: "2017-05-17T23:59:59Z",
      type: "instrument",
      platform: "ground",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-17-lma2-stations",
      shortName: "lma_stations",
      displayName: "West Texas LMA Stations",
      variableName: "Station Location",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/LMA_asset/WTXLMA_stations.czml`,
      date: "2017-05-17",
      start: "2017-05-17T00:00:00Z",
      end: "2017-05-17T23:59:59Z",
      type: "instrument",
      platform: "ground",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-17-track15",
      shortName: "flight15",
      displayName: "Flight Track",
      czmlLocation: `${flightTrackBaseUrl}/flight_track/goesrplt_naver2_IWG1_20170517-1010`,
      start: "2017-05-17T00:36:38Z",
      end: "2017-05-17T10:10:02Z",
      date: "2017-05-17",
      type: "track",
      platform: "air",
      displayMechanism: "czml",
    },
  ]
  
  const layers_2017_05_14 = [
    {
      layerId: "2017-05-14-abi-13",
      fieldCampaignName: "GOES-R PLT",
      shortName: "abi_c13",
      displayName: "Advanced Baseline Imager",
      variableName: "Channel 13",
      date: "2017-05-14",
      start: "2017-05-14T00:00:00Z",
      end: "2017-05-14T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      displayMechanism: "wmts",
      url: `${abiBaseUrl}/development/singleband/C13/{Time}/{TileMatrix}/{TileCol}/{TileRow}.png?colormap=cloud`,
      format: "image/png",
      style: "default",
      times: [
        "548034438",
        "548034738",
        "548035338",
        "548035638",
        "548035938",
        "548036238",
        "548036538",
        "548036838",
        "548037138",
        "548037438",
        "548037738",
        "548038038",
        "548038338",
        "548038638",
        "548038938",
        "548039238",
        "548039538",
        "548039838",
        "548040138",
        "548040438",
        "548040738",
        "548041038",
        "548041338",
        "548041638",
        "548041938",
        "548042238",
        "548042538",
        "548042838",
        "548043138",
        "548043438",
        "548043738",
        "548044038",
        "548044338",
        "548044638",
        "548044938",
        "548045238",
        "548045538",
        "548045838",
        "548046138",
        "548046438",
        "548046738",
        "548047038",
        "548047338",
        "548047638",
        "548047938",
        "548048238",
        "548048538",
        "548048838",
        "548049138",
        "548049438",
        "548050638",
        "548050938",
        "548051238",
        "548051538",
        "548051838",
        "548052138",
        "548052438",
        "548052738",
        "548053038",
        "548053338",
        "548053638",
        "548053938",
        "548054238",
        "548054538",
        "548054838",
        "548055138",
        "548055438",
        "548055738",
        "548056038",
        "548056338",
        "548056638",
        "548056938",
        "548057238",
        "548057538",
        "548057838",
        "548058138",
        "548058438",
        "548058738",
      ],
      tileMatrixSetID: "2km",
      layer: "ABI_Channel_13",
    },
    {
      layerId: "2017-05-14-glm",
      fieldCampaignName: "GOES-R PLT",
      shortName: "glm",
      displayName: "Geostationary Lightning Mapper",
      variableName: "Lightning Events",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-14/glm_czml_1min/GLM_tiles.czml`,
      date: "2017-05-14",
      start: "2017-05-14T00:00:00Z",
      end: "2017-05-14T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-14-glp",
      fieldCampaignName: "GOES-R PLT",
      shortName: "glm",
      addOnTickEventListener: true,
      displayName: "GLM Points",
      variableName: "Lightning Events",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-14/glm_points/GLMpoints.json`,
      date: "2017-05-14",
      start: "2017-05-14T00:00:00Z",
      end: "2017-05-14T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      dispType: 'Intensity',
      displayMechanism: "points",
    },
    {
      layerId: "2017-05-14-isslis",
      fieldCampaignName: "GOES-R PLT",
      shortName: "isslis",
      displayName: "ISS LIS",
      variableName: "Lightning Events",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-14/iss-lis_czml/LIS_tiles.czml`,
      start: "2017-05-14T13:19:58Z",
      end: "2017-05-14T13:21:33Z",
      date: "2017-05-14",
      type: "instrument",
      platform: "satellite",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-14-lisp",
      fieldCampaignName: "GOES-R PLT",
      shortName: "isslis",
      addOnTickEventListener: true,
      displayName: "LIS Points",
      variableName: "Lightning Events",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-14/iss-lis_points/LISpoints.json`,
      start: "2017-05-14T13:19:58Z",
      end: "2017-05-14T13:21:33Z",
      date: "2017-05-14",
      type: "instrument",
      dispType: 'LIntensity',
      platform: "satellite",
      displayMechanism: "points",
    },
    {
      layerId: "2017-05-14-crs",
      fieldCampaignName: "GOES-R PLT",
      shortName: "goesrpltcrs",
      addOnTickEventListener: true,
      displayName: "Cloud Radar System",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-14/crs/tileset.json`,
      date: "2017-05-14",
      start: "2017-05-14T12:55:46Z",
      end: "2017-05-14T18:31:29Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "3dtile",
    },
    {
      layerId: "2017-05-14-cpl",
      fieldCampaignName: "GOES-R PLT",
      shortName: "goesrpltcpl",
      addOnTickEventListener: true,
      displayName: "Cloud Physics LiDAR",
      variableName: "Radar Reflectivity",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-14/cpl/cpl_atb/tileset.json`,
      date: "2017-05-14",
      start: "2017-05-14T12:55:46Z",
      end: "2017-05-14T18:31:29Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "3dtile",
    },
    {
      layerId: "2017-05-14-fegs",
      shortName: "goesrpltfegs",
      displayName: "Fly's Eye GLM Event Simulator",
      variableName: "Lightning Radiance Detected",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-14/fegs/FEGS_Flash.czml`,
      date: "2017-05-14",
      start: "2017-05-14T12:55:46Z",
      end: "2017-05-14T18:31:29Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-14-lip",
      shortName: "goesrpltlip",
      displayName: "Lightning Instrument Package",
      variableName: "Electric Field",
      unit: "kV/m",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-14/lip/LIP.czml`,
      date: "2017-05-14",
      start: "2017-05-14T12:55:46Z",
      end: "2017-05-14T18:31:29Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-14-lma",
      shortName: "goesrpltoklma",
      displayName: "Oklahoma Lightning Mapping Array (LMA)",
      variableName: "Lightning Events",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-14/lma/KSCLMA_tiles.czml`,
      date: "2017-05-14",
      start: "2017-05-14T00:00:00Z",
      end: "2017-05-14T23:59:59Z",
      type: "instrument",
      platform: "ground",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-14-lma-stations",
      shortName: "lma_stations",
      displayName: "Oklahoma LMA Stations",
      variableName: "Station Location",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/LMA_asset/KSCLMA_stations.czml`,
      date: "2017-05-14",
      start: "2017-05-14T00:00:00Z",
      end: "2017-05-14T23:59:59Z",
      type: "instrument",
      platform: "ground",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-14-track14",
      shortName: "flight14",
      displayName: "Flight Track",
      czmlLocation: `${flightTrackBaseUrl}/flight_track/goesrplt_naver2_IWG1_20170514-1922`,
      start: "2017-05-14T10:04:54Z",
      end: "2017-05-14T19:22:07Z",
      date: "2017-05-14",
      type: "track",
      platform: "air",
      displayMechanism: "czml",
    },
  ]
  
  const layers_2017_05_12 = [
    {
      layerId: "2017-05-12-abi-13",
      fieldCampaignName: "GOES-R PLT",
      shortName: "abi_c13",
      displayName: "Advanced Baseline Imager",
      variableName: "Channel 13",
      date: "2017-05-12",
      start: "2017-05-12T00:00:00Z",
      end: "2017-05-12T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      displayMechanism: "wmts",
      url: `${abiBaseUrl}/development/singleband/C13/{Time}/{TileMatrix}/{TileCol}/{TileRow}.png?colormap=cloud`,
      format: "image/png",
      style: "default",
      times: [
        "547868538",
        "547868838",
        "547869138",
        "547869438",
        "547869738",
        "547870038",
        "547870338",
        "547870638",
        "547870938",
        "547871238",
        "547871538",
        "547871838",
        "547872138",
        "547872438",
        "547872738",
        "547873038",
        "547873338",
        "547873638",
        "547873938",
        "547874238",
        "547874538",
        "547874838",
        "547875138",
        "547875438",
        "547875738",
        "547876038",
        "547876338",
        "547876638",
        "547876938",
        "547877238",
        "547877538",
        "547877838",
        "547878138",
        "547878438",
        "547878738",
        "547879038",
        "547879338",
        "547879638",
        "547879938",
        "547880238",
        "547880538",
        "547880838",
        "547881138",
        "547881438",
        "547881738",
        "547882038",
        "547882338",
        "547882638",
        "547882938",
        "547883238",
        "547883538",
        "547883838",
        "547884138",
        "547884438",
        "547884738",
        "547885038",
        "547885338",
        "547885638",
        "547885938",
        "547886238",
        "547886538",
        "547886838",
        "547887138",
        "547887438",
        "547887738",
        "547888038",
        "547888338",
        "547888638",
        "547888938",
        "547889238",
        "547889538",
        "547889838",
        "547890138",
        "547890438",
        "547890738",
        "547891038",
        "547891338",
        "547891638",
        "547891938",
        "547892238",
        "547892538",
      ],
      tileMatrixSetID: "2km",
      layer: "ABI_Channel_13",
    },
    {
      layerId: "2017-05-12-glm",
      fieldCampaignName: "GOES-R PLT",
      shortName: "glm",
      displayName: "Geostationary Lightning Mapper",
      variableName: "Lightning Events",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-12/glm_czml_1min/GLM_tiles.czml`,
      date: "2017-05-12",
      start: "2017-05-12T00:00:00Z",
      end: "2017-05-12T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-12-glp",
      fieldCampaignName: "GOES-R PLT",
      shortName: "glm",
      addOnTickEventListener: true,
      displayName: "GLM Points",
      variableName: "Lightning Events",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-12/glm_points/GLMpoints.json`,
      date: "2017-05-12",
      start: "2017-05-12T00:00:00Z",
      end: "2017-05-12T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      dispType: 'Intensity',
      displayMechanism: "points",
    },  
    {
      layerId: "2017-05-12-isslis",
      fieldCampaignName: "GOES-R PLT",
      shortName: "isslis",
      displayName: "ISS LIS",
      variableName: "Lightning Events",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-12/iss-lis_czml/LIS_tiles.czml`,
      start: "2017-05-12T15:00:55Z",
      end: "2017-05-12T15:02:10Z",
      date: "2017-05-12",
      type: "instrument",
      platform: "satellite",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-12-lisp",
      fieldCampaignName: "GOES-R PLT",
      shortName: "isslis",
      addOnTickEventListener: true,
      displayName: "LIS Points",
      variableName: "Lightning Events",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-12/iss-lis_points/LISpoints.json`,
      start: "2017-05-12T15:00:55Z",
      end: "2017-05-12T15:02:10Z",
      date: "2017-05-12",
      type: "instrument",
      dispType: 'LIntensity',
      platform: "satellite",
      displayMechanism: "points",
    },
    {
      layerId: "2017-05-12-crs",
      fieldCampaignName: "GOES-R PLT",
      shortName: "goesrpltcrs",
      addOnTickEventListener: true,
      displayName: "Cloud Radar System",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-12/crs/tileset.json`,
      date: "2017-05-12",
      start: "2017-05-12T13:42:09Z",
      end: "2017-05-12T19:44:33Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "3dtile",
    },
    {
      layerId: "2017-05-12-cpl",
      fieldCampaignName: "GOES-R PLT",
      shortName: "goesrpltcpl",
      addOnTickEventListener: true,
      displayName: "Cloud Physics LiDAR",
      variableName: "Radar Reflectivity",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-12/cpl/cpl_atb/tileset.json`,
      date: "2017-05-12",
      start: "2017-05-12T13:42:09Z",
      end: "2017-05-12T19:44:33Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "3dtile",
    },
    {
      layerId: "2017-05-12-fegs",
      shortName: "goesrpltfegs",
      displayName: "Fly's Eye GLM Event Simulator",
      variableName: "Lightning Radiance Detected",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-12/fegs/FEGS_Flash.czml`,
  
      date: "2017-05-12",
      start: "2017-05-12T13:42:09Z",
      end: "2017-05-12T19:44:33Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-12-lip",
      shortName: "goesrpltlip",
      displayName: "Lightning Instrument Package",
      variableName: "Electric Field",
      unit: "kV/m",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-14/lip/LIP.czml`,
      date: "2017-05-12",
      start: "2017-05-12T13:42:09Z",
      end: "2017-05-12T19:44:33Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-12-track13",
      shortName: "flight13",
      displayName: "Flight Track",
      czmlLocation: `${flightTrackBaseUrl}/flight_track/goesrplt_naver2_IWG1_20170512-2104`,
      start: "2017-05-12T11:54:15Z",
      end: "2017-05-12T21:04:57Z",
      date: "2017-05-12",
      type: "track",
      platform: "air",
      displayMechanism: "czml",
    },
  ]
  
  const layers_2017_05_08 = [
    {
      layerId: "2017-05-08-abi-13",
      fieldCampaignName: "GOES-R PLT",
      shortName: "abi_c13",
      displayName: "Advanced Baseline Imager",
      variableName: "Channel 13",
      date: "2017-05-08",
      start: "2017-05-08T00:00:00Z",
      end: "2017-05-08T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      displayMechanism: "wmts",
      url: `${abiBaseUrl}/development/singleband/C13/{Time}/{TileMatrix}/{TileCol}/{TileRow}.png?colormap=cloud`,
      format: "image/png",
      style: "default",
      times: [
        "547543940",
        "547544240",
        "547544540",
        "547544840",
        "547545140",
        "547545440",
        "547545740",
        "547546040",
        "547546340",
        "547546640",
        "547546940",
        "547547240",
        "547547540",
        "547547840",
        "547548140",
        "547548440",
        "547548740",
        "547549040",
        "547549340",
        "547549640",
        "547549940",
        "547550240",
        "547550540",
        "547550840",
        "547551440",
        "547551740",
        "547552040",
        "547552340",
        "547552640",
        "547553540",
        "547553840",
        "547554140",
        "547554440",
        "547554740",
        "547555040",
        "547555340",
        "547555640",
        "547555940",
        "547556540",
        "547556840",
        "547557440",
        "547557740",
        "547558040",
        "547558340",
        "547558640",
        "547558940",
        "547559240",
        "547559540",
        "547559840",
      ],
      tileMatrixSetID: "2km",
      layer: "ABI_Channel_13",
    },
    {
      layerId: "2017-05-08-glp",
      fieldCampaignName: "GOES-R PLT",
      shortName: "glm",
      addOnTickEventListener: true,
      displayName: "GLM Points",
      variableName: "Lightning Events",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-08/glm_points/GLMpoints.json`,
      date: "2017-05-08",
      start: "2017-05-08T20:30:02Z",
      end: "2017-05-09T03:11:41Z",
      type: "instrument",
      platform: "satellite",
      dispType: 'Intensity',
      displayMechanism: "points",
    },
    {
      layerId: "2017-05-08-crs",
      fieldCampaignName: "GOES-R PLT",
      shortName: "goesrpltcrs",
      addOnTickEventListener: true,
      displayName: "Cloud Radar System",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-08/crs/tileset.json`,
      date: "2017-05-08",
      start: "2017-05-08T20:30:02Z",
      end: "2017-05-09T03:11:41Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "3dtile",
    },
    {
      layerId: "2017-05-08-cpl",
      fieldCampaignName: "GOES-R PLT",
      shortName: "goesrpltcpl",
      addOnTickEventListener: true,
      displayName: "Cloud Physics LiDAR",
      variableName: "Radar Reflectivity",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-08/cpl/cpl_atb/tileset.json`,
      date: "2017-05-08",
      start: "2017-05-08T20:30:02Z",
      end: "2017-05-09T03:11:41Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "3dtile",
    },
    {
      layerId: "2017-05-08-fegs",
      shortName: "goesrpltfegs",
      displayName: "Fly's Eye GLM Event Simulator",
      variableName: "Lightning Radiance Detected",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-08/fegs/FEGS_Flash.czml`,
  
      date: "2017-05-08",
      start: "2017-05-08T20:30:02Z",
      end: "2017-05-09T03:11:41Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-08-lip",
      shortName: "goesrpltlip",
      displayName: "Lightning Instrument Package",
      variableName: "Electric Field",
      unit: "kV/m",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-08/lip/LIP.czml`,
      date: "2017-05-08",
      start: "2017-05-08T20:30:02Z",
      end: "2017-05-09T03:11:41Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-08-lma",
      shortName: "goesrpltcolma",
      displayName: "Colorado Lightning Mapping Array (LMA)",
      variableName: "Lightning Events",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-08/lma/COLMA_tiles.czml`,
      date: "2017-05-08",
      start: "2017-05-08:00:00Z",
      end: "2017-05-08T23:59:59Z",
      type: "instrument",
      platform: "ground",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-08-lma-stations",
      shortName: "lma_stations",
      displayName: "Colorado LMA Stations",
      variableName: "Station Location",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/LMA_asset/COLMA_stations.czml`,
      date: "2017-05-08",
      start: "2017-05-08T00:00:00Z",
      end: "2017-05-08T23:59:59Z",
      type: "instrument",
      platform: "ground",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-08-track12",
      shortName: "flight12",
      displayName: "Flight Track",
      czmlLocation: `${flightTrackBaseUrl}/flight_track/goesrplt_naver2_IWG1_20170509-0412`,
      start: "2017-05-08T17:51:39Z",
      end: "2017-05-09T04:12:19Z",
      date: "2017-05-08",
      type: "track",
      platform: "air",
      displayMechanism: "czml",
    },
  ]
  
  const layers_2017_05_07 = [
    {
      layerId: "2017-05-07-abi-13",
      fieldCampaignName: "GOES-R PLT",
      shortName: "abi_c13",
      displayName: "Advanced Baseline Imager",
      variableName: "Channel 13",
      date: "2017-05-07",
      start: "2017-05-07T00:00:00Z",
      end: "2017-05-07T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      displayMechanism: "wmts",
      url: `${abiBaseUrl}/development/singleband/C13/{Time}/{TileMatrix}/{TileCol}/{TileRow}.png?colormap=cloud`,
      format: "image/png",
      style: "default",
      times: [
        "547441340",
        "547441640",
        "547441940",
        "547442240",
        "547442540",
        "547442840",
        "547443140",
        "547443440",
        "547443740",
        "547444040",
        "547444340",
        "547444640",
        "547444940",
        "547445240",
        "547445540",
        "547445840",
        "547446140",
        "547446440",
        "547446740",
        "547447040",
        "547447340",
        "547447640",
        "547447940",
        "547448240",
        "547448540",
        "547448840",
        "547449140",
        "547449440",
        "547449740",
        "547450040",
        "547450340",
        "547450640",
        "547450940",
        "547451240",
        "547451540",
        "547451840",
        "547452140",
        "547452440",
        "547452740",
        "547453040",
        "547453340",
        "547453640",
        "547453940",
        "547454240",
        "547454540",
        "547454840",
        "547455140",
        "547455440",
      ],
      tileMatrixSetID: "2km",
      layer: "ABI_Channel_13",
    },
    {
      layerId: "2017-05-07-glm",
      fieldCampaignName: "GOES-R PLT",
      shortName: "glm",
      displayName: "Geostationary Lightning Mapper",
      variableName: "Lightning Events",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-07/glm_czml_1min/GLM_tiles.czml`,
      date: "2017-05-07",
      start: "2017-05-07T00:00:00Z",
      end: "2017-05-07T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-05-07-glp",
      fieldCampaignName: "GOES-R PLT",
      shortName: "glm",
      addOnTickEventListener: true,
      displayName: "GLM Points",
      variableName: "Lightning Events",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-07/glm_points/GLMpoints.json`,
      date: "2017-05-07",
      start: "2017-05-07T00:00:00Z",
      end: "2017-05-07T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      dispType: 'Intensity',
      displayMechanism: "points",
    },
    {
      layerId: "2017-05-07-crs",
      fieldCampaignName: "GOES-R PLT",
      shortName: "goesrpltcrs",
      addOnTickEventListener: true,
      displayName: "Cloud Radar System",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-07/crs/tileset.json`,
      date: "2017-05-07",
      start: "2017-05-07T16:08:45Z",
      end: "2017-05-07T18:55:35Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "3dtile",
    },
    {
      layerId: "2017-05-07-cpl",
      fieldCampaignName: "GOES-R PLT",
      shortName: "goesrpltcpl",
      addOnTickEventListener: true,
      displayName: "Cloud Physics LiDAR",
      variableName: "Radar Reflectivity",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-05-07/cpl/cpl_atb/tileset.json`,
      date: "2017-05-07",
      start: "2017-05-07T16:08:45Z",
      end: "2017-05-07T18:55:35Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "3dtile",
    },  
    {
      layerId: "2017-05-07-track11",
      shortName: "flight11",
      displayName: "Flight Track",
      czmlLocation: `${flightTrackBaseUrl}/flight_track/goesrplt_naver2_IWG1_20170507-2001`,
      start: "2017-05-07T13:06:19Z",
      end: "2017-05-07T20:01:22Z",
      date: "2017-05-07",
      type: "track",
      platform: "air",
      displayMechanism: "czml",
    },
  ]
  
  const layers_2017_04_22 = [
    {
      layerId: "2017-04-22-abi-13",
      fieldCampaignName: "GOES-R PLT",
      shortName: "abi_c13",
      displayName: "Advanced Baseline Imager",
      variableName: "Channel 13",
      date: "2017-04-22",
      start: "2017-04-22T00:00:00Z",
      end: "2017-04-22T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      displayMechanism: "wmts",
      url: `${abiBaseUrl}/development/singleband/C13/{Time}/{TileMatrix}/{TileCol}/{TileRow}.png?colormap=cloud`,
      format: "image/png",
      style: "default",
      times: [
        "546163338",
        "546163638",
        "546163938",
        "546164238",
        "546164538",
        "546164838",
        "546165138",
        "546165438",
        "546165738",
        "546166038",
        "546166338",
        "546166638",
        "546166938",
        "546167238",
        "546167538",
        "546167838",
        "546168138",
        "546168438",
        "546168738",
        "546169038",
        "546169338",
        "546169638",
        "546169938",
        "546170238",
        "546170538",
        "546170838",
        "546171138",
        "546171438",
        "546171738",
        "546172038",
        "546172338",
        "546172638",
        "546172938",
        "546173238",
        "546173538",
        "546173838",
        "546174138",
        "546174438",
        "546174738",
        "546175038",
        "546175338",
        "546175638",
        "546175938",
        "546176238",
        "546176538",
        "546176838",
        "546177138",
        "546177438",
      ],
      tileMatrixSetID: "2km",
      layer: "ABI_Channel_13",
    },
    {
      layerId: "2017-04-22-glm",
      fieldCampaignName: "GOES-R PLT",
      shortName: "glm",
      displayName: "Geostationary Lightning Mapper",
      variableName: "Lightning Events",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-22/glm_czml_1min/GLM_tiles.czml`,
      date: "2017-04-22",
      start: "2017-04-22T00:00:00Z",
      end: "2017-04-22T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-04-22-glp",
      fieldCampaignName: "GOES-R PLT",
      shortName: "glm",
      addOnTickEventListener: true,
      displayName: "GLM Points",
      variableName: "Lightning Events",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-22/glm_points/GLMpoints.json`,
      date: "2017-04-22",
      start: "2017-04-22T00:00:00Z",
      end: "2017-04-22T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      dispType: 'Intensity',
      displayMechanism: "points",
    },
    {
      layerId: "2017-04-22-lisp",
      fieldCampaignName: "GOES-R PLT",
      shortName: "isslis",
      addOnTickEventListener: true,
      displayName: "LIS Points",
      variableName: "Lightning Events",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-22/iss-lis_points/LISpoints.json`,
      date: "2017-04-22",
      start: "2017-04-22T00:00:00Z",
      end: "2017-04-22T23:59:59Z",
      type: "instrument",
      dispType: 'LIntensity',
      platform: "satellite",
      displayMechanism: "points",
    },
    {
      layerId: "2017-04-22-crs",
      fieldCampaignName: "GOES-R PLT",
      shortName: "goesrpltcrs",
      addOnTickEventListener: true,
      displayName: "Cloud Radar System",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-22/crs/tileset.json`,
      date: "2017-04-22",
      start: "2017-04-22T20:01:04Z",
      end: "2017-04-23T00:43:03Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "3dtile",
    },
    {
      layerId: "2017-04-22-cpl",
      fieldCampaignName: "GOES-R PLT",
      shortName: "goesrpltcpl",
      addOnTickEventListener: true,
      displayName: "Cloud Physics LiDAR",
      variableName: "Radar Reflectivity",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-22/cpl/cpl_atb/tileset.json`,
      date: "2017-04-22",
      start: "2017-04-22T20:01:04Z",
      end: "2017-04-23T00:43:03Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "3dtile",
    },
    {
      layerId: "2017-04-22-fegs",
      shortName: "goesrpltfegs",
      displayName: "Fly's Eye GLM Event Simulator",
      variableName: "Lightning Radiance Detected",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-22/fegs/FEGS_Flash.czml`,
  
      date: "2017-04-22",
      start: "2017-04-22T20:01:04Z",
      end: "2017-04-23T00:43:03Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-04-22-lip",
      shortName: "goesrpltlip",
      displayName: "Lightning Instrument Package",
      variableName: "Electric Field",
      unit: "kV/m",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-22/lip/LIP.czml`,
      date: "2017-04-22",
      start: "2017-04-22T20:01:04Z",
      end: "2017-04-23T00:43:03Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-04-22-lma",
      shortName: "goesrpltnalma",
      displayName: "North Alabama Lightning Mapping Array (LMA)",
      variableName: "Lightning Events",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-22/lma/NALMA_tiles.czml`,
      date: "2017-04-22",
      start: "2017-04-22:00:00Z",
      end: "2017-04-22T23:59:59Z",
      type: "instrument",
      platform: "ground",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-04-22-lma-stations",
      shortName: "lma_stations",
      displayName: "North Alabama LMA Stations",
      variableName: "Station Location",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/LMA_asset/NALMA_stations.czml`,
      date: "2017-04-22",
      start: "2017-04-22T00:00:00Z",
      end: "2017-04-22T23:59:59Z",
      type: "instrument",
      platform: "ground",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-04-22-track9",
      shortName: "flight9",
      displayName: "Flight Track",
      czmlLocation: `${flightTrackBaseUrl}/flight_track/goesrplt_naver2_IWG1_20170423-0142`,
      start: "2017-04-22T18:30:19Z",
      end: "2017-04-23T01:42:12Z",
      date: "2017-04-22",
      type: "track",
      platform: "air",
      displayMechanism: "czml",
    },
  ]
  
  const layers_2017_04_20 = [
    {
      layerId: "2017-04-20-abi-13",
      fieldCampaignName: "GOES-R PLT",
      shortName: "abi_c13",
      displayName: "Advanced Baseline Imager",
      variableName: "Channel 13",
      date: "2017-04-20",
      start: "2017-04-20T00:00:00Z",
      end: "2017-04-20T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      displayMechanism: "wmts",
      url: `${abiBaseUrl}/development/singleband/C13/{Time}/{TileMatrix}/{TileCol}/{TileRow}.png?colormap=cloud`,
      format: "image/png",
      style: "default",
      times: [
        "545997738",
        "545998038",
        "545998338",
        "545998638",
        "545998938",
        "545999238",
        "545999538",
        "545999838",
        "546000138",
        "546000438",
        "546000738",
        "546001038",
        "546001338",
        "546001638",
        "546001938",
        "546002238",
        "546002538",
        "546002838",
        "546003138",
        "546003438",
        "546003738",
        "546004038",
        "546004338",
        "546004638",
      ],
      tileMatrixSetID: "2km",
      layer: "ABI_Channel_13",
    },
    {
      layerId: "2017-04-20-glm",
      fieldCampaignName: "GOES-R PLT",
      shortName: "glm",
      displayName: "Geostationary Lightning Mapper",
      variableName: "Lightning Events",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-20/glm_czml_1min/GLM_tiles.czml`,
      date: "2017-04-20",
      start: "2017-04-20T00:00:00Z",
      end: "2017-04-20T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-04-20-glp",
      fieldCampaignName: "GOES-R PLT",
      shortName: "glm",
      addOnTickEventListener: true,
      displayName: "GLM Points",
      variableName: "Lightning Events",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-20/glm_points/GLMpoints.json`,
      date: "2017-04-20",
      start: "2017-04-20T00:00:00Z",
      end: "2017-04-20T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      dispType: 'Intensity',
      displayMechanism: "points",
    },
    {
      layerId: "2017-04-20-crs",
      fieldCampaignName: "GOES-R PLT",
      shortName: "goesrpltcrs",
      addOnTickEventListener: true,
      displayName: "Cloud Radar System",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-20/crs/tileset.json`,
      date: "2017-04-20",
      start: "2017-04-20T22:05:01Z",
      end: "2017-04-21T04:02:45Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "3dtile",
    },
    {
      layerId: "2017-04-20-cpl",
      fieldCampaignName: "GOES-R PLT",
      shortName: "goesrpltcpl",
      addOnTickEventListener: true,
      displayName: "Cloud Physics LiDAR",
      variableName: "Radar Reflectivity",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-20/cpl/cpl_atb/tileset.json`,
      date: "2017-04-20",
      start: "2017-04-20T22:05:01Z",
      end: "2017-04-21T04:02:45Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "3dtile",
    },
    {
      layerId: "2017-04-20-fegs",
      shortName: "goesrpltfegs",
      displayName: "Fly's Eye GLM Event Simulator",
      variableName: "Lightning Radiance Detected",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-20/fegs/FEGS_Flash.czml`,
  
      date: "2017-04-20",
      start: "2017-04-20T22:05:01Z",
      end: "2017-04-21T04:02:45Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-04-20-lip",
      shortName: "goesrpltlip",
      displayName: "Lightning Instrument Package",
      variableName: "Electric Field",
      unit: "kV/m",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-20/lip/LIP.czml`,
      date: "2017-04-20",
      start: "2017-04-20T22:05:01Z",
      end: "2017-04-21T04:02:45Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-04-20-lma",
      shortName: "goesrpltcolma",
      displayName: "Southern Ontario Lightning Mapping Array (LMA)",
      variableName: "Lightning Events",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-20/lma/SOLMA_tiles.czml`,
      date: "2017-04-20",
      start: "2017-04-20:00:00Z",
      end: "2017-04-20T23:59:59Z",
      type: "instrument",
      platform: "ground",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-04-20-lma-stations",
      shortName: "lma_stations",
      displayName: "Southern Ontario LMA Stations",
      variableName: "Station Location",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/LMA_asset/SOLMA_stations.czml`,
      date: "2017-04-20",
      start: "2017-04-20T00:00:00Z",
      end: "2017-04-20T23:59:59Z",
      type: "instrument",
      platform: "ground",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-04-20-track8",
      shortName: "flight8",
      displayName: "Flight Track",
      czmlLocation: `${flightTrackBaseUrl}/flight_track/goesrplt_naver2_IWG1_20170421-0459`,
      start: "2017-04-20T20:22:47Z",
      end: "2017-04-21T04:59:20Z",
      date: "2017-04-20",
      type: "track",
      platform: "air",
      displayMechanism: "czml",
    },
  ]
  
  const layers_2017_04_18 = [
    {
      layerId: "2017-04-18-abi-13",
      fieldCampaignName: "GOES-R PLT",
      shortName: "abi_c13",
      displayName: "Advanced Baseline Imager",
      variableName: "Channel 13",
      date: "2017-04-18",
      start: "2017-04-18T00:00:00Z",
      end: "2017-04-18T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      displayMechanism: "wmts",
      url: `${abiBaseUrl}/development/singleband/C13/{Time}/{TileMatrix}/{TileCol}/{TileRow}.png?colormap=cloud`,
      format: "image/png",
      style: "default",
      times: [
        "545808142",
        "545808442",
        "545808742",
        "545809042",
        "545809342",
        "545809642",
        "545809942",
        "545810242",
        "545810542",
        "545810842",
        "545811142",
        "545811442",
        "545811742",
        "545812042",
        "545812342",
        "545812642",
        "545812942",
        "545813242",
        "545813542",
        "545813842",
        "545814142",
        "545814442",
        "545814742",
        "545815042",
        "545815342",
        "545815642",
        "545815942",
        "545816242",
        "545816542",
        "545816842",
        "545817142",
        "545817442",
        "545817742",
        "545818042",
        "545818342",
        "545818642",
        "545818942",
        "545819242",
        "545819542",
        "545819842",
        "545820142",
        "545820442",
        "545820742",
        "545821042",
        "545821342",
        "545821642",
        "545821942",
        "545822242",
        "545822542",
        "545822842",
        "545823142",
        "545823442",
        "545823742",
        "545824042",
        "545824342",
        "545824642",
        "545824942",
        "545825242",
        "545825542",
        "545825842",
        "545826142",
        "545826442",
      ],
      tileMatrixSetID: "2km",
      layer: "ABI_Channel_13",
    },
    {
      layerId: "2017-04-18-glm",
      fieldCampaignName: "GOES-R PLT",
      shortName: "glm",
      displayName: "Geostationary Lightning Mapper",
      variableName: "Lightning Events",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-18/glm_czml_1min/GLM_tiles.czml`,
      date: "2017-04-18",
      start: "2017-04-18T00:00:00Z",
      end: "2017-04-18T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-04-18-glp",
      fieldCampaignName: "GOES-R PLT",
      shortName: "glm",
      addOnTickEventListener: true,
      displayName: "GLM Points",
      variableName: "Lightning Events",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-18/glm_points/GLMpoints.json`,
      date: "2017-04-18",
      start: "2017-04-18T00:00:00Z",
      end: "2017-04-18T23:59:59Z",
      type: "instrument",
      platform: "satellite",
      dispType: 'Intensity',
      displayMechanism: "points",
    },
    {
      layerId: "2017-04-18-crs",
      fieldCampaignName: "GOES-R PLT",
      shortName: "goesrpltcrs",
      addOnTickEventListener: true,
      displayName: "Cloud Radar System",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-18/crs/tileset.json`,
      date: "2017-04-18",
      start: "2017-04-18T17:22:12Z",
      end: "2017-04-18T22:30:03Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "3dtile",
    },
    {
      layerId: "2017-04-18-cpl",
      fieldCampaignName: "GOES-R PLT",
      shortName: "goesrpltcpl",
      addOnTickEventListener: true,
      displayName: "Cloud Physics LiDAR",
      variableName: "Radar Reflectivity",
      unit: "dBZ",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-18/cpl/cpl_atb/tileset.json`,
      date: "2017-04-18",
      start: "2017-04-18T17:22:12Z",
      end: "2017-04-18T22:30:03Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "3dtile",
    },
    {
      layerId: "2017-04-18-fegs",
      shortName: "goesrpltfegs",
      displayName: "Fly's Eye GLM Event Simulator",
      variableName: "Lightning Radiance Detected",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-18/fegs/FEGS_Flash.czml`,
  
      date: "2017-04-18",
      start: "2017-04-18T17:22:12Z",
      end: "2017-04-18T22:30:03Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-04-18-lip",
      shortName: "goesrpltlip",
      displayName: "Lightning Instrument Package",
      variableName: "Electric Field",
      unit: "kV/m",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-18/lip/LIP.czml`,
      date: "2017-04-18",
      start: "2017-04-18T17:22:12Z",
      end: "2017-04-18T22:30:03Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-04-18-lma",
      shortName: "goesrpltnalma",
      displayName: "North Alabama Lightning Mapping Array (LMA)",
      variableName: "Lightning Events",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-18/lma/NALMA_tiles.czml`,
      date: "2017-04-18",
      start: "2017-04-18:00:00Z",
      end: "2017-04-18T23:59:59Z",
      type: "instrument",
      platform: "ground",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-04-18-lma-stations",
      shortName: "lma_stations",
      displayName: "North Alabama LMA Stations",
      variableName: "Station Location",
      czmlLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/LMA_asset/NALMA_stations.czml`,
      date: "2017-04-18",
      start: "2017-04-18T00:00:00Z",
      end: "2017-04-18T23:59:59Z",
      type: "instrument",
      platform: "ground",
      displayMechanism: "czml",
    },
    {
      layerId: "2017-04-18-track7",
      shortName: "flight7",
      displayName: "Flight Track",
      czmlLocation: `${flightTrackBaseUrl}/flight_track/goesrplt_naver2_IWG1_20170418-2321`,
      start: "2017-04-18T15:53:53Z",
      end: "2017-04-18T23:21:18Z",
      date: "2017-04-18",
      type: "track",
      platform: "air",
      displayMechanism: "czml",
    },
  ]
  
  const layers_2017_04_16 = [
    {
      layerId: "2017-04-16-crs",
      fieldCampaignName: "GOES-R PLT",
      shortName: "goesrpltcrs",
      addOnTickEventListener: true,
      displayName: "Cloud Radar System",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-16/crs/tileset.json`,
      date: "2017-04-16",
      start: "2017-04-16T06:53:10Z",
      end: "2017-04-16T13:30:49Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "3dtile",
    },
  
    {
      layerId: "2017-04-16-track6",
      shortName: "flight6",
      displayName: "Flight Track",
      czmlLocation: `${flightTrackBaseUrl}/flight_track/goesrplt_naver2_IWG1_20170416-1433`,
      start: "2017-04-16T05:25:49Z",
      end: "2017-04-16T14:33:19Z",
      date: "2017-04-16",
      type: "track",
      platform: "air",
      displayMechanism: "czml",
    },
  ]
  
  const layers_2017_04_13 = [
    {
      layerId: "2017-04-13-crs",
      fieldCampaignName: "GOES-R PLT",
      shortName: "goesrpltcrs",
      addOnTickEventListener: true,
      displayName: "Cloud Radar System",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-13/crs/tileset.json`,
      date: "2017-04-13",
      start: "2017-04-13T05:46:43Z",
      end: "2017-04-13T08:40:23Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "3dtile",
    },
  
    {
      layerId: "2017-04-13-track5",
      shortName: "flight5",
      displayName: "Flight Track",
      czmlLocation: `${flightTrackBaseUrl}/flight_track/goesrplt_naver2_IWG1_20170413-0933`,
      start: "2017-04-13T04:11:37Z",
      end: "2017-04-13T09:33:08Z",
      date: "2017-04-13",
      type: "track",
      platform: "air",
      displayMechanism: "czml",
    },
  ]
  
  const layers_2017_04_11 = [
    {
      layerId: "2017-04-11-crs",
      fieldCampaignName: "GOES-R PLT",
      shortName: "goesrpltcrs",
      addOnTickEventListener: true,
      displayName: "Cloud Radar System",
      tileLocation: `${dataBaseUrl}/fieldcampaign/goesrplt/2017-04-11/crs/tileset.json`,
      date: "2017-04-11",
      start: "2017-04-11T16:29:39Z",
      end: "2017-04-11T20:11:50Z",
      type: "instrument",
      platform: "air",
      displayMechanism: "3dtile",
    },
  
    {
      layerId: "2017-04-11-track4",
      shortName: "flight4",
      displayName: "Flight Track",
      czmlLocation: `${flightTrackBaseUrl}/flight_track/goesrplt_naver2_IWG1_20170411-2104`,
      start: "2017-04-11T14:38:24Z",
      end: "2017-04-11T21:04:12Z",
      date: "2017-04-11",
      type: "track",
      platform: "air",
      displayMechanism: "czml",
    },
  ]
  
  const layers = [
    { date: "2017-05-17", items: [...layers_2017_05_17] },
    { date: "2017-05-14", items: [...layers_2017_05_14] },
    { date: "2017-05-12", items: [...layers_2017_05_12] },
    { date: "2017-05-08", items: [...layers_2017_05_08] },
    { date: "2017-05-07", items: [...layers_2017_05_07] },
    { date: "2017-04-22", items: [...layers_2017_04_22] },
    { date: "2017-04-20", items: [...layers_2017_04_20] },
    { date: "2017-04-18", items: [...layers_2017_04_18] },
    { date: "2017-04-16", items: [...layers_2017_04_16] },
    { date: "2017-04-13", items: [...layers_2017_04_13] },
    { date: "2017-04-11", items: [...layers_2017_04_11] },
  ]
  
  const defaultCamera = {
    "2017-05-17": {
      position: { x: -524172.7277183009, y: -5657999.256355947, z: 3584222.1257714718 },
      direction: { x: -0.37803890258305844, y: 0.918222704592939, z: 0.11812558107296396 },
      up: { x: -0.45552938673436577, y: -0.2955713287926675, z: 0.8397205293531589 },
      right: { x: 0.8059649905270139, y: 0.2636373538893252, z: 0.5300148862805886 },
      currentTime: { dayNumber: 2457890, secondsOfDay: 63977.72180175781 },
    },
    "2017-05-14": {
      position: { x: 2178874.724313431, y: -6252303.521673192, z: 2830275.025980942 },
      direction: { x: -0.6397966148728539, y: 0.7196893691232018, z: 0.26964328949240535 },
      up: { x: -0.21680367143594015, y: -0.5056113590934348, z: 0.8350768357508109 },
      right: { x: 0.7373306311615802, y: 0.47581967753208537, z: 0.47951973350856814 },
      currentTime: { dayNumber: 2457888, secondsOfDay: 3755.5650040790497 },
    },
    "2017-05-12": {
      position: { x: 65143.423491472764, y: -6203708.13909823, z: 3338199.5936485906 },
      direction: { x: -0.22578753209405716, y: 0.919548869695837, z: -0.3216362333319797 },
      up: { x: -0.036516707319017225, y: 0.32194114087798253, z: 0.946055194952578 },
      right: { x: 0.9734919210951123, y: 0.22535256388887975, z: -0.03911139873816887 },
      currentTime: { dayNumber: 2457886, secondsOfDay: 11524.583133158085 },
    },
    "2017-05-08": {
      position: { x: -1235847.037688778, y: -5971053.208145021, z: 3791794.350195169 },
      direction: { x: 0.2708484059900073, y: 0.9407842566978865, z: 0.20387771659030685 },
      up: { x: 0.039188420181043904, y: -0.22239470062198305, z: 0.9741688071679222 },
      right: { x: 0.9618240008943354, y: -0.25586242296332584, z: -0.09710309891527685 },
      currentTime: { dayNumber: 2457882, secondsOfDay: 34022.14075826226 },
    },
    "2017-05-07": {
      position: { x: 383150.7385508645, y: -6102054.480581832, z: 2989863.176161124 },
      direction: { x: 0.4164537943433999, y: 0.8651398046313485, z: 0.2794626193597587 },
      up: { x: 0.40723924991551064, y: -0.452335514192032, z: 0.7934410979580541 },
      right: { x: 0.812848344099462, y: -0.21662340834513283, z: -0.5406957263116663 },
      currentTime: { dayNumber: 2457881, secondsOfDay: 16521.277218816627 },
    },
    "2017-04-22": {
      position: { x: 651910.0197374136, y: -5706034.644790848, z: 3500282.5532267555 },
      direction: { x: -0.5709243330353628, y: 0.8137710244971768, z: 0.10872959871599605 },
      up: { x: -0.4062558648026333, y: -0.3951062886861959, z: 0.8239218366775363 },
      right: { x: 0.7134434653576909, y: 0.4262249879223833, z: 0.5561750456546694 },
      currentTime: { dayNumber: 2457866, secondsOfDay: 31903.615171908314 },
    },
    "2017-04-20": {
      position: { x: 1439874.0547038694, y: -5873136.991224899, z: 4025748.741465703 },
      direction: { x: -0.5065975885451839, y: 0.8605012578778073, z: 0.05381884865840236 },
      up: { x: -0.2940964377854414, y: -0.2311448057298534, z: 0.9274046387990641 },
      right: { x: 0.8104728055660589, y: 0.45399302194507324, z: 0.3701677558392434 },
      currentTime: { dayNumber: 2457864, secondsOfDay: 40930.376365938166 },
    },
    "2017-04-18": {
      position: { x: -344015.423607644, y: -6307939.697720082, z: 3431379.033174837 },
      direction: { x: 0.45266196963943467, y: 0.8521362594199577, z: 0.26260414433879403 },
      up: { x: 0.3174856106756625, y: -0.4292276197904687, z: 0.8455569391962381 },
      right: { x: 0.8332466791149242, y: -0.29937843240749895, z: -0.46483602049881995 },
      currentTime: { dayNumber: 2457862, secondsOfDay: 36509.10557702559 },
    },
    "2017-04-16": {
      position: { x: -519117.0749613384, y: -5942214.302724532, z: 3627442.555083079 },
      direction: { x: -0.08209743777715942, y: 0.9675111828349041, z: 0.2391278356859157 },
      up: { x: -0.01800701478353004, y: -0.241338630670049, z: 0.9702738854389988 },
      right: { x: 0.9964616189944353, y: 0.07535102146428106, z: 0.03723527138719795 },
      currentTime: { dayNumber: 2457859, secondsOfDay: 84591.4254064499 },
    },
    "2017-04-13": {
      position: { x: 625158.7377961937, y: -6404342.747871498, z: 2429234.4498217995 },
      direction: { x: -0.30239205339377284, y: 0.7709096751531099, z: 0.5605865845697916 },
      up: { x: -0.09103270749245318, y: -0.6087890327533645, z: 0.7880919741792937 },
      right: { x: 0.948826692400088, y: 0.1872810357578936, z: 0.2542709606592139 },
      currentTime: { dayNumber: 2457856, secondsOfDay: 68840.64822094883 },
    },
    "2017-04-11": {
      position: { x: -1852154.7106053238, y: -5893127.762248108, z: 3558553.308301238 },
      direction: { x: 0.46073616857629673, y: 0.8875202700975857, z: 0.005472945417517361 },
      up: { x: 0.04316589008708232, y: -0.028566891559038403, z: 0.9986594207434505 },
      right: { x: 0.8864868238719762, y: -0.459882270665616, z: -0.051472402594135894 },
      currentTime: { dayNumber: 2457855, secondsOfDay: 21126.767623933905 },
    },
  }
  
  const goes_r_plt_campaign = {
    title: "GOES-R PLT Field Campaign",
    logo: `${dataBaseUrl}/fieldcampaign/goesrplt/logo/GOES-R_logo_small.png`,
    description: "The GOES-R PLT field campaign was a collaborative mission to validate the Advanced Baseline Imager (ABI) and Geostationary Lightning Mapper (GLM) instruments aboard the GOES-R, now GOES-16, satellite.",
    links: [
      {
        url: "https://ghrc.nsstc.nasa.gov/uso/ds_details/collections/goesrpltC.html",
        title: "Landing Page",
      },
      {
        url: "https://ghrc.nsstc.nasa.gov/home/micro-articles/goes-r-post-launch-test-plt",
        title: "Micro Article",
      },
      {
        url: "https://ghrc.nsstc.nasa.gov/home/field-campaigns/goes-r_plt",
        title: "Description",
      },
      {
        url: "https://ghrc.nsstc.nasa.gov/home/field-campaigns/goes-r_plt/instruments",
        title: "Instruments",
      },
    ],
    dois: [
      {
        shortName: "goesrpltcrs",
        longName: "GOES-R PLT Cloud Radar System (CRS)",
        doi: "http://dx.doi.org/10.5067/GOESRPLT/CRS/DATA101",
      },
      {
        shortName: "goesrpltaviris",
        longName: "GOES-R PLT Airborne Visible/Infrared Imaging Spectrometer (AVIRIS)",
        doi: "http://dx.doi.org/10.5067/GOESRPLT/AVIRIS/DATA101",
      },
      {
        shortName: "goesrpltdclma",
        longName: "GOES-R PLT Washington D.C. Lightning Mapping Array (LMA)",
        doi: "http://dx.doi.org/10.5067/GOESRPLT/LMA/DATA201",
      },
      {
        shortName: "goesrpltsolma",
        longName: "GOES-R PLT Southern Ontario Lightning Mapping Array (LMA)",
        doi: "http://dx.doi.org/10.5067/GOESRPLT/LMA/DATA601",
      },
      {
        shortName: "goesrpltredlake",
        longName: "GOES-R PLT Surface Radiance Red Lake",
        doi: "http://dx.doi.org/10.5067/GOESRPLT/RAD/DATA101",
      },
      {
        shortName: "goesrpltivanpah",
        longName: "GOES-R PLT Surface Radiance Ivanpah",
        doi: "http://dx.doi.org/10.5067/GOESRPLT/RAD/DATA201",
      },
      {
        shortName: "goesrpltavirisng",
        longName: "GOES-R PLT Field Campaign Airborne Visible/Infrared Imaging Spectrometer Next Generation (AVIRIS-NG)",
        doi: "http://dx.doi.org/10.5067/GOESRPLT/AVIRISNG/DATA101",
      },
      {
        shortName: "goesrpltcpl",
        longName: "GOES-R PLT Cloud Physics LiDAR (CPL)",
        doi: "http://dx.doi.org/10.5067/GOESRPLT/CPL/DATA101",
      },
      {
        shortName: "goesrpltshis",
        longName: "GOES-R PLT Scanning High-Resolution Interferometer Sounder (S-HIS)",
        doi: "http://dx.doi.org/10.5067/GOESRPLT/SHIS/DATA101",
      },
      {
        shortName: "goesrpltgcas",
        longName: "GOES-R PLT Geostationary Coastal and Air Pollution Event (GEO-CAPE) Airborne Simulator (GCAS)",
        doi: "http://dx.doi.org/10.5067/GOESRPLT/GCAS/DATA101",
      },
      {
        shortName: "goesrpltfegs",
        longName: "GOES-R PLT Fly's Eye GLM Simulator (FEGS)",
        doi: "http://dx.doi.org/10.5067/GOESRPLT/FEGS/DATA101",
      },
      {
        shortName: "goesrpltlip",
        longName: "GOES-R PLT Lightning Instrument Package (LIP)",
        doi: "http://dx.doi.org/10.5067/GOESRPLT/LIP/DATA101",
      },
      {
        shortName: "goesrpltnaver2",
        longName: "GOES-R PLT ER-2 Flight Navigation Data",
        doi: "http://dx.doi.org/10.5067/GOESRPLT/INS/DATA101",
      },
      {
        shortName: "goesrpltmisrep",
        longName: "GOES-R PLT Mission Reports",
        doi: "http://dx.doi.org/10.5067/GOESRPLT/REPORTS/DATA101",
      },
      {
        shortName: "goesrpltoklma",
        longName: "GOES-R PLT Oklahoma Lightning Mapping Array (LMA)",
        doi: "http://dx.doi.org/10.5067/GOESRPLT/LMA/DATA501",
      },
      {
        shortName: "goesrpltnalma",
        longName: "GOES-R PLT North Alabama Lightning Mapping Array (LMA)",
        doi: "http://dx.doi.org/10.5067/GOESRPLT/LMA/DATA401",
      },
      {
        shortName: "goesrpltksclma",
        longName: " GOES-R PLT Kennedy Space Center Lightning Mapping Array (LMA)",
        doi: "http://dx.doi.org/10.5067/GOESRPLT/LMA/DATA301",
      },
      {
        shortName: "goesrpltwtlma",
        longName: "GOES-R PLT West Texas Lightning Mapping Array (LMA)",
        doi: "http://dx.doi.org/10.5067/GOESRPLT/LMA/DATA701",
      },
      {
        shortName: "goesrpltcolma",
        longName: "GOES-R PLT Colorado Lightning Mapping Array (LMA)",
        doi: "http://dx.doi.org/10.5067/GOESRPLT/FEGS/DATA101",
      },
    ],
    layers: layers,
    legends: {
      goesrpltcrs: { url: `${dataBaseUrl}/fieldcampaign/goesrplt/legend/crs_legend.png`, color: "magenta" },
      goesrpltcpl: { url: `${dataBaseUrl}/fieldcampaign/goesrplt/legend/crs_legend.png`, color: "magenta" },
      track: { url: `${dataBaseUrl}/fieldcampaign/goesrplt/legend/flighttrack_legend.png`, color: "darkgreen" },
      abi_c13: { url: `${dataBaseUrl}/fieldcampaign/goesrplt/legend/abi_c13_legend.png`, color: "lightgray" },
      lma_stations: { url: `${dataBaseUrl}/fieldcampaign/goesrplt/legend/lma_stations_legend.png`, color: "lightred" },
      goesrpltwtlma: { url: `${dataBaseUrl}/fieldcampaign/goesrplt/legend/lma_legend.png`, color: "lightblue" },
      goesrpltksclma: { url: `${dataBaseUrl}/fieldcampaign/goesrplt/legend/lma_legend.png`, color: "lightblue" },
      goesrpltsolma: { url: `${dataBaseUrl}/fieldcampaign/goesrplt/legend/lma_legend.png`, color: "lightblue" },
      goesrpltcolma: { url: `${dataBaseUrl}/fieldcampaign/goesrplt/legend/lma_legend.png`, color: "lightblue" },
      goesrpltnalma:  { url: `${dataBaseUrl}/fieldcampaign/goesrplt/legend/lma_legend.png`, color: "lightblue" },
      glm:            { url: `${dataBaseUrl}/fieldcampaign/goesrplt/legend/glm_legend.png`, color: "lightgreen" },
      goesrpltfegs:   { url: `${dataBaseUrl}/fieldcampaign/goesrplt/legend/fegs_legend.png`, color: "lightgreen" },
      goesrpltlip:    { url: `${dataBaseUrl}/fieldcampaign/goesrplt/legend/lip_legend.png`, color: "red" },
      glm_intensity:  { url: `${dataBaseUrl}/fieldcampaign/goesrplt/legend/glm_legend.png`, color: "yellow" },
      isslis:         { url: `${dataBaseUrl}/fieldcampaign/goesrplt/legend/isslis_legend.png`, color: "cyan" },
      goesrpltoklma:   { url: `${dataBaseUrl}/fieldcampaign/goesrplt/legend/lma_legend.png`, color: "lightred" },
    },

    defaultCamera: defaultCamera,
  }
  
  export default goes_r_plt_campaign
  
  /*
  GOES-R PLT Flights
  
  Date  Day/Night
  04/18 Day
  04/20 Night (started out in the afternoon)
  04/22 Day
  05/07 Day <--basically very little data for this day
  05/08 Day
  05/12 Day
  05/14 Day
  05/17 Night
  */
  